<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="customBack"
      [title]="'Bill'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="isLoggedIntoClientApp">
          <tidy-text
            [title]="'Bill From'" />
          @if (isLoggedIntoClientApp) {
            <div style="margin-right: -5px">
              <tidy-text
                [body]="'Copy Link'"
                (action)="copyBillLink()"
                class="link" />
            </div>
          }
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="proName | titlecase"
            [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="proEmail"
            [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="proPhone | telephone" />
        </tidy-row>
        <div style="position: relative; margin-left: -11px; margin-right: -11px; padding: 10px;">
          <div style="position: absolute; top: 0; left: 0; right: 0; height: 7px; background: #275C7C;"></div>
          <div style="padding-top: 7px">
            <tidy-row [alignLastItemRight]="true">
              <div>
                <tidy-text
                  [body]="'To: '" />
                <tidy-text
                  [body]="((companyName || clientName) | titlecase)"
                  [translate]="false" />
              </div>
              <div style="align-self: end; margin-right: -5px">
                <tidy-text
                  [body]="('Sent ' | translate) + (invoice?.created_at | parseDateTime:'MMM d':'local')" />
              </div>
            </tidy-row>
          </div>
        </div>
        <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
          <tidy-text
            [body]="'Service'" />
          <tidy-text
            [body]="'Owed'" />
        </tidy-row>
        <tidy-row>
          <tidy-divider />
        </tidy-row>
        @for (service of invoice?.items; track service; let last = $last) {
          <tidy-row [alignLastItemRight]="true">
            <div style="width:85%">
              <tidy-text
                [header]="service?.service_details?.name | titlecase" />
            </div>
            <div>
              @if (service?.amount) {
                <tidy-text
                  [body]="service?.amount | tcurrency" />
              }
              @if (!service?.amount) {
                <tidy-text
                  [body]="invoice?.amount | tcurrency" />
              }
            </div>
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="(service?.service_details?.date | parseDateTime:'MMM d') + (' at ' | translate) + service?.service_details?.address?.address + ', ' + (service?.service_details?.address?.unit ? (('Unit ' | translate) + (service?.service_details?.address?.unit | translate) + ', ') : '') + service?.service_details?.address?.zip" />
          </tidy-row>
          @if (!clientHubInfo) {
            <tidy-row class="extra-top-padding vertical-align-center">
              <tidy-image
                [src]="'assets/img/clock-black.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Job Duration'" />
              @if (!proReportedDuration && !fromStartDuration) {
                <tidy-text
                  [body]="': N/A'" />
              }
            </tidy-row>
          }
          @if (proReportedDuration) {
            <tidy-row>
              <tidy-text
                [body]="'Reported by Pro:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="proReportedDuration" />
              </tidy-row>
            }
            @if (fromStartDuration) {
              <tidy-row>
                <tidy-text
                  [body]="'Using Realtime Updates:'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="fromStartDuration" />
                </tidy-row>
              }
              <tidy-row [ngClass] = "last ? '' : 'extra-bottom-padding'">
                <tidy-divider />
              </tidy-row>
            }
            @if (creditWithPro > 0) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text
                  [header]="'Credit with Pro'" />
                <tidy-text
                  [body]="creditWithPro | tcurrency" />
              </tidy-row>
            }
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                [header]="'Total'" />
              <tidy-text
                [body]="'<b>' + ((totalOwed) | tcurrency) + '</b>'" />
              </tidy-row>
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="'We thank you for your business!'" />
              </tidy-row>
              <tidy-row class="no-padding" [align]="'center'">
                <tidy-text
                  [body]="proName"
                  class="signature"
                  [translate]="false" />
              </tidy-row>
              <tidy-divider
                style="margin-top:-15px" />
              @if (isLoggedIntoClientApp) {
                <ng-container class="no-padding">
                  <tidy-row class="extra-top-padding">
                    <tidy-text
                      [header]="'Bill Notes'" />
                  </tidy-row>
                  <tidy-row style="padding-bottom: 0px">
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-select
                        style="width:35%; font-size: 8px"
                        [form]="form.controls.messageType"
                        formControlName="messageType"
                        [items]="messageSelectItems"
                        [smallText]="true"
                        [selectedItem]="selectedMessageType"
                        (optionChange)="updateIsInternalComment($event)"
                        [icon]="'assets/svg/chatbubble.svg'" />
                    </form>
                  </tidy-row>
                  <form [formGroup]="form" novalidate action="#">
                    <tidy-textarea
                      [label]="isInternalComment ? 'Add Internal Note' : 'Add Note'"
                      formControlName="message"
                      [form]="form.controls.message"
                      [submitted]="submitted"
                      [errorMessage]="'Please enter a message to send.'"
                      [rightIconAction]="boundSendMessage"
                      [leftIconAction]="boundSendAttachment" />
                  </form>
                  @if (invoiceNotes?.length == 0) {
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [helper]="'No Bill Notes'" />
                    </tidy-row>
                  }
                  <tidy-row />
                  @if (!showAllInvoiceNotes) {
                    @for (note of invoiceNotes | slice:0:3; track note; let last = $last) {
                      <message
                        [message]="note"
                        [last]="last"
                        [isInvoiceNote]="true" />
                    }
                    @if (invoiceNotes?.length > 3) {
                      <tidy-row [align]="'center'">
                        <tidy-text
                          [actionBody]="'Show All Notes'"
                          (action)="toggleShowAllInvoiceNotes()"
                          class="link" />
                      </tidy-row>
                    }
                  }
                  @if (showAllInvoiceNotes) {
                    @for (note of invoiceNotes; track note; let last = $last) {
                      <message
                        [message]="note"
                        [last]="last"
                        [isInvoiceNote]="true" />
                    }
                  }
                </ng-container>
              }
            </tidy-card>
            <tidy-card>
              <form [formGroup]="form" novalidate action="#">
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [title]="'Pay Bill'" />
                </tidy-row>
                @if (invoice?.credits_to_use?.length > 0) {
                  <tidy-row>
                    <tidy-text
                      [body]="'Select which of your credits to use'" />
                  </tidy-row>
                }
                @for (credit of invoice?.credits_to_use; track credit) {
                  <tidy-checkbox
                    [formControlName]="credit?.title + '_checkbox'"
                    [form]="form.controls[credit?.title + '_checkbox']"
                    [items]="[{viewValue: credit?.title + ' (' + (credit?.processing_fee_percentage) + '% ' + ('processing fee' | translate) + ')', value: true}]"
                    (checkedChange)="checkUncheckCredit(credit)" />
                }
                @for (credit of selectedCredits; track credit) {
                  <div style="display: flex; align-items: center;">
                    <tidy-input
                      [formControlName]="credit.title"
                      [form]="form.controls[credit.title]"
                      [mask]="'currencyMask'"
                      [errorMessage]="'Please enter an amount.'"
                      [submitted]="submitted"
                      style="margin-right: 10px;"
                      [icon]="'assets/svg/cash.svg'" />
                    <tidy-text
                      [helper]="'of'" /><span>&nbsp;</span>
                      <tidy-text
                        [helper]="credit.available_amount | tcurrency" />
                    </div>
                  }
                  @if (showTooMuchCreditSelectedWarning && !showNotEnoughCreditWarning) {
                    <tidy-row>
                      <tidy-text
                        [helper]="'You entered more credit than the amount owed. We will only use credit for the amount owed.'" />
                    </tidy-row>
                  }
                  @if (showNotEnoughCreditWarning) {
                    <tidy-row>
                      <tidy-text
                        [body]="'You entered more credit than you have. Please enter up to the amount you have.'"
                        class="red" />
                    </tidy-row>
                  }
                  @if (isVendorInvoice && noCompatibleMethods) {
                    <tidy-alert>
                      <tidy-row>
                        <tidy-text
                          [body]="'Vendor invoices can only be paid by check. Add a check payment method to continue.'" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [actionBody]="'Add Check Payment Method'"
                          (action)="goToAddCheckPaymentMethod()"
                          class="link" />
                      </tidy-row>
                    </tidy-alert>
                  }
                  @if (showPaymentMethodOptions && !showNotEnoughCreditWarning && !(isVendorInvoice && noCompatibleMethods)) {
                    <tidy-row class="extra-top-padding" [ngClass]="{'extra-bottom-padding': form?.value?.howToPay === 'newCard'}">
                      @if (howToPayLabel) {
                        <tidy-radio-button
                          [label]="howToPayLabel"
                          formControlName="howToPay"
                          [form]="form.controls.howToPay"
                          [items]="howToPayItems"
                          (optionChange)="updateHowToPay($event)"
                          [submitted]="submitted"
                          [errorMessage]="'Please select a payment method.'" />
                      }
                      @if (!howToPayLabel) {
                        <tidy-radio-button
                          formControlName="howToPay"
                          [form]="form.controls.howToPay"
                          [items]="howToPayItems"
                          (optionChange)="updateHowToPay($event)"
                          [submitted]="submitted"
                          [errorMessage]="'Please select a payment method.'" />
                      }
                    </tidy-row>
                    @if (form?.value?.howToPay === 'newCard') {
                      <div class="form-row">
                        <div id="card-info" #cardInfo></div>
                      </div>
                      @if (!lastFourCC) {
                        <tidy-checkbox
                          [(checked)]="saveCardForFuture"
              [items]="[
                {
                  viewValue: 'Save Card For Future Use', value: true
                }
              ]"
                        [initValue]="saveCardForFuture" />
                    }
                  }
                  @if (!isAuthenticated && (form?.value?.howToPay === 'currentCard' || (form?.value?.howToPay === 'newCard' && saveCardForFuture))) {
                    <tidy-row class="extra-top-padding extra-bottom-padding" [ngClass]="form?.value?.howToPay === 'newCard' ? 'extra-top-padding' : ''">
                      <tidy-text
                        [header]="getCardTitle()" />
                    </tidy-row>
                    @if (!hasAccount) {
                      <tidy-row class="field-top-padding field-bottom-padding">
                        <tidy-input
                          formControlName="firstName"
                          [form]="form.controls.firstName"
                          [label]="'First Name'"
                          [errorMessage]="'Please enter your first name.'"
                          [submitted]="submitted"
                          [icon]="'assets/svg/person.svg'" />
                      </tidy-row>
                      <tidy-row class="field-bottom-padding">
                        <tidy-input
                          formControlName="lastName"
                          [form]="form.controls.lastName"
                          [label]="'Last Name'"
                          [errorMessage]="'Please enter your last name.'"
                          [submitted]="submitted"
                          [icon]="'assets/svg/person.svg'" />
                      </tidy-row>
                    }
                    <tidy-row class="field-bottom-padding" [ngClass]="hasAccount ? 'field-top-padding' : ''">
                      <tidy-input
                        formControlName="email"
                        [form]="form.controls.email"
                        [label]="'Email'"
                        [icon]="'assets/svg/mail.svg'"
                        [errorMessage]="'Please enter a valid email.'"
                        [submitted]="submitted"
                        type="email" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-input
                        formControlName="password"
                        [form]="form.controls.password"
                        [label]="'Password'"
                        [icon]="'assets/svg/lock-closed.svg'"
                        [type]="'password'"
                        [errorMessage]="'Please enter a password.'"
                        [submitted]="submitted" />
                    </tidy-row>
                    @if (!hasAccount) {
                      <tidy-row class="extra-top-padding vertical-align-center">
                        <!-- TODO address inline styles: https://trello.com/c/XpKJZqE7/9010-f-ca-address-inline-styles-->
                        <tidy-checkbox
                          style="margin-right: 5px"
                          formControlName="terms"
                          [form]="form.controls.terms"
                          [items]="[{viewValue: '', value: true}]" />
                        <tidy-text
                          [body]="'I agree to the'" /><span>&nbsp;</span>
                          <tidy-text
                            (action)="openTerms()"
                            [body]="'terms'"
                            class="link" />
                        </tidy-row>
                      }
                      @if (termsError) {
                        <tidy-row>
                          <tidy-error-message
                            [text]="'You must agree to the terms to continue.'" />
                        </tidy-row>
                      }
                    }
                    @if (form?.value?.howToPay === 'newCard' && !newCard) {
                      <div style="display: flex; align-content: center; justify-content: center;">
                        <re-captcha (resolved)="captchaEvents($event)" />
                      </div>
                      @if (captchaErrorMessage) {
                        <tidy-error-message
                          [text]="'Please check that you are not a robot.'" />
                      }
                      <tidy-button
                        style="margin-top: 10px;"
                        [action]="addNewCard"
                        [text]="'Save Card'"
                        class="secondary" />
                    }
                    @if (form?.value?.howToPay === 'alreadyPaid') {
                      <tidy-row class="field-top-padding">
                        <tidy-select
                          [label]="'Select payment method'"
                          [form]="form.controls.otherOptions"
                          formControlName="otherOptions"
                          [items]="otherOptionItems"
                          (optionChange)="getSelectedOtherOption($event)"
                          [errorMessage]="'Please select a payment method.'"
                          [submitted]="submitted"
                          [icon]="'assets/svg/cash.svg'" />
                      </tidy-row>
                      @if (selectedOtherOption?.third_party_account_name || selectedOtherOption?.notes) {
                        <tidy-row class="extra-top-padding">
                          <tidy-text
                            [header]="'Pay With'" /><span>&nbsp;</span>
                            <tidy-text
                              [header]="selectedOtherOption?.team_payment_option_type?.name" />
                          </tidy-row>
                        }
                        @if (selectedOtherOption?.third_party_account_name) {
                          <tidy-row class="extra-bottom-padding">
                            <tidy-text
                              [body]="'Username:'" />
                            <tidy-text
                              [body]="selectedOtherOption?.third_party_account_name +  ' '"
                              [translate]="false" />
                            <tidy-text
                              [body]="'Copy'"
                              class="link"
                              (action)="copyToClipBoard(selectedOtherOption?.third_party_account_name)" />
                            @if (copied) {
                              <span>&nbsp;</span>
                              <tidy-text
                                [helper]="'Copied'" />
                            }
                          </tidy-row>
                        }
                        @if (selectedOtherOption?.notes) {
                          <tidy-row>
                            <tidy-text
                              [body]="selectedOtherOption?.notes" />
                          </tidy-row>
                        }
                      }
                      @if (showACHDebitMessage) {
                        <tidy-row>
                          <tidy-text
                            [body]="'You can load credit via ACH debit or credit card '" />
                          <tidy-text
                            [actionBody]="'here'"
                            class="link"
                            (action)="goToLoadCredit()" />
                        </tidy-row>
                      }
                    }
                  </form>
                </tidy-card>

                <tidy-card>
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
                      [title]="'Payment Summary'" />
                  </tidy-row>
                  @if (!paymentPreview && !showNotEnoughCreditWarning && !showTooMuchCreditSelectedWarning) {
                    <tidy-loader />
                  }
                  @if (showNotEnoughCreditWarning || showTooMuchCreditSelectedWarning) {
                    <tidy-row>
                      <tidy-text
                        [helper]="'Please select a valid credit amount to see the payment summary.'" />
                    </tidy-row>
                  }
                  @if (form.value.howToPay === 'newCard') {
                    <tidy-row>
                      <tidy-text
                        [helper]="'Add your new card to see the payment summary.'" />
                    </tidy-row>
                  }
                  @if (form.value.howToPay === 'alreadyPaid') {
                    <tidy-row>
                      @if (form.value.otherOptions !== 'achDebit') {
                        <tidy-text
                          [helper]="'There will be no payment for your selected option.'" />
                      }
                      @if (form.value.otherOptions == 'achDebit') {
                        <tidy-text
                          [helper]="'Add credit to view the payment summary.'" />
                      }
                    </tidy-row>
                  }
                  @if (form.value.howToPay !== 'newCard' && form.value.howToPay !== 'alreadyPaid' && paymentPreview) {
                    @for (item of paymentPreview.items; track item) {
                      @for (payment of item.preview.cleaning_detail.payments; track payment) {
                        <tidy-row>
                          <tidy-text
                            [body]="getFromTitle(payment.from_type)"/>
                          <tidy-text
                            [body]="' - ' + (payment.amount | tcurrency)"/>
                          @if (payment.fee.amount > 0) {
                            <tidy-text
                              [body]="' + ' + (payment.fee.amount | tcurrency) + ' (' + payment.fee.percentage + '% ' + ('processing fee' | translate) + ')'"/>
                          }
                        </tidy-row>
                      }
                    }
                    <tidy-row class="extra-top-padding">
                      <tidy-text
                        [header]="'Total Cost: '" />
                      <tidy-text
                        [header]="(paymentPreview.total_fee_amount + totalOwed) | tcurrency" />
                    </tidy-row>
                  }
                </tidy-card>

                @if (errorMessage) {
                  <tidy-error-message
                    [text]="errorMessage" />
                }

                <tidy-button
                  [disabled]="!paymentPreview || showNotEnoughCreditWarning || showTooMuchCreditSelectedWarning || showACHDebitMessage || (form?.value?.howToPay == 'newCard' && !newCard)"
                  [action]="boundPayInvoice"
                  [text]="form?.value?.howToPay === 'alreadyPaid' ? 'Mark as Paid' : 'Pay Bill'"
                  class="primary" />
              }

              @if (!loaded) {
                <tidy-card>
                  <tidy-row class="extra-bottom-padding">
                    <tidy-grid>
                      <tidy-row>
                        <ion-row>
                          <ion-col size="6">
                            <tidy-row>
                              <ion-skeleton-text animated="true" style="width: 150px; height: 20px" />
                            </tidy-row>
                            <tidy-row>
                              <ion-skeleton-text animated style="width: 90px" />
                            </tidy-row>
                            <tidy-row>
                              <ion-skeleton-text animated style="width: 105px" />
                            </tidy-row>
                          </ion-col>
                        </ion-row>
                      </tidy-row>
                    </tidy-grid>
                  </tidy-row>
                  <div style="height: 50px; position: relative; margin-left: -11px; margin-right: -11px; padding: 10px;">
                    <div style="position: absolute; top: 0; left: 0; right: 0; height: 7px; background: #275C7C;"></div>
                  </div>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 60px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 90px" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-divider />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 80px; height: 15px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 110px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 80%" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-divider />
                  </tidy-row>
                  <!--TODO
                  <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
                    <tidy-text
                      [header]="'Credit Applied'">
                    </tidy-text>
                    <tidy-text
                      [body]="'-$20'">
                    </tidy-text>
                  </tidy-row>
                  <tidy-row [alignLastItemRight]="true" class="extra-top-padding extra-bottom-padding">
                    <tidy-text
                      [header]="'Payment Recorded'">
                    </tidy-text>
                    <tidy-text
                      [body]="'-$10'">
                    </tidy-text>
                  </tidy-row>-->
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 60px; height: 15px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 180px; margin: auto" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 270px; height: 35px; margin: auto" />
                  </tidy-row>
                  <tidy-divider />
                </tidy-card>
                <tidy-card>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 115px; height: 20px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 150px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 180px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 120px" />
                  </tidy-row>
                  <tidy-row>
                    <ion-skeleton-text animated style="width: 115px" />
                  </tidy-row>
                </tidy-card>
                <tidy-row>
                  <ion-skeleton-text animated style="height: 50px" />
                </tidy-row>
              }

            </tidy-wrapper>
          </ng-template>

          @if (!isRightSideContent) {
            <app-scroll-wrapper [templateContent]="content" />
          }

          @if (isRightSideContent) {
            <ion-content class="ion-content-right-column">
              <ng-container *ngTemplateOutlet="content" />
            </ion-content>
          }
